import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import * as $ from 'jquery';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { UserSettingsService } from 'src/app/user-settings/user-settings.service';
import { environment } from 'src/environments/environment';
import { RecommendationService } from '../../recommendation/recommendation.service';


@Component({
  selector: 'app-r-q31',
  templateUrl: './r-q31.component.html',
  styleUrls: ['./r-q31.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ31Component implements OnInit {
  @Input() data: any;
  @ViewChild('scrollMe', { static: true })
  private myScrollContainer: ElementRef;
  @ViewChild('input', { static: true }) input: ElementRef<HTMLInputElement>;
  airport = '';
  question;
  questions;
  user_bot: Boolean = false;
  userResponses = [];
  index;
  findNonEmpty;
  questionObj;
  showTip = false;
  months = [];
  url;
  monthValue;
  validation = false;
  showbutton = true;
  deviceWidth;
  timer;

  addAddressFlow = false;
  questionNotifyObj;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  updateObj = {
    processCompleted: '',
    showNotification: '',
  };
  question_q1;
  display = 'none';
  private unsubscribe = new Subject<void>();
  limit: number;
  private loadPropertyValues = {
    Apartmentorcondominium: 'Apt or Condo',
    Singlefamilyhome: 'Single Family Home',
    Manufacturedhome: 'Manufactured Home',
    Townhouse: 'Townhouse',
  };
  loadSqftSizeValues: any;
  private actualUtilityName = {
    AEPTexasCentral: 'AEPC',
    AEPTexasNorth: 'AEPN',
    TexasNewMexicoPower: 'TNMP',
    CenterPointEnergy: 'CNP',
    Oncor: 'ONCOR',

    CenterPoint: 'CNP',
    AEPC: 'AEPC',
    AEPN: 'AEPN',
    TNMP:'TNMP'
  };

  constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private http: HttpClient,
    private recommendationService: RecommendationService,
    private userSettingsService: UserSettingsService
  ) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    const today = new Date();
    let pastMonth = today.getMonth() - 1;
    let currentYear = today.getFullYear();
    if (pastMonth < 0) {
      pastMonth = 11;
      currentYear = today.getFullYear() - 1;
    }
    const month = new Array(
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    );
    const monthformat = new Array(
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    );

    for (let i = 0; i < 12; i++) {
      this.months.push({
        month: month[pastMonth],
        year: currentYear,
        usage: '',
        monthformat: monthformat[pastMonth],
      });

      pastMonth--;
      if (pastMonth < 0) {
        pastMonth = 11;
        currentYear = today.getFullYear() - 1;
      }
    }

    this.months.sort((a, b) => {
      const monthOrder = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month);
    });

    this.url = environment.api_url;
  }

  ngOnInit() {
    this.limit = 5;
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.residentialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }

    if (this.deviceWidth > 768) {
      const splitQuestion = this.question.split('usage ');
      this.question = splitQuestion[0] + 'usage';
      this.question_q1 = splitQuestion[1];
    }

    // if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
    //   const obj = _.findWhere(this.userResponses, {
    //     res_question_id: this.questionObj._id,
    //   });
    //   if (!_.isEmpty(obj)) {
    //     this.months = obj.fieldValue;
    //     this.user_bot = true;
    //     if (this.deviceWidth < 768) {
    //       this.goNext();
    //     }
    //   }
    // }
    this.scrollToBottom();
    $('#form').on('focus', 'input[type=number]', function (e) {
      $(this).on('mousewheel.disableScroll', function (e) {
        e.preventDefault();
      });
    });
    $('#form').on('blur', 'input[type=number]', function (e) {
      $(this).off('mousewheel.disableScroll');
    });
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  goKey(event, i) {
    if (event.keyCode === 13) {
      let isEmpty = false;
      _.each(this.months, function (item) {
        if (
          !isEmpty &&
          (item.usage === '' || item.usage === undefined || item.usage === null)
        ) {
          this.validation = true;
          isEmpty = true;
        }
      });
      if (isEmpty) {
        document.getElementById((i + 1).toString()).focus();
      } else {
        this.next();
      }
    }
  }

  getMonthsDetails() {
    const monthElements = document.getElementsByClassName('monthrender');
    for (let i = 0; i < monthElements.length; i++) {
      monthElements[i].classList.add('valueEntered');
    }
    const MonthsObj = {
      January: '1166',
      Feb: '1016',
      Mar: '899',
      Apr: '872',
      May: '1003',
      Jun: '1380',
      Jul: '1646',
      Aug: '1725',
      Sep: '1689',
      Oct: '1469',
      Nov: '1144',
      Dec: '995',
    };
    let dwelling_type, sqft, utility;
    window.scrollTo(0, document.body.scrollHeight);
    // this.assignClassPerValueEntered(monthElements);
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      dwelling_type = this.setDwellingTypeForProperty();
      sqft = this.setSqftValuePerSize();
      utility = this.setUtilityName();
    }
    var queryObj = {
      dwelling_type: dwelling_type,
      sqft: sqft,
      utility: utility,
    };
    const body = new HttpParams().append('queryObj', JSON.stringify(queryObj));
    this.http
      .post(this.url + '/getmothsDetails', body)
      .takeUntil(this.unsubscribe)
      .subscribe((res: any) => {
        
        let result = res[0];
        let month = this.months;
        for (var i in month) {
          if (
            month[i].month == 'January' &&
            (month[i].usage == null ||
              month[i].usage == '' ||
              month[i].usage == '')
          ) {
            month[i].usage = result ? result.JAN : '1166';
          } else if (
            month[i].month == 'January' &&
            month[i].usage != undefined
          ) {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'February' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.FEB : '1016';
          } else if (
            month[i].month == 'February' &&
            this.months[i].usage != ''
          ) {
            month[i].usage = this.months[i].usage;
          }

          if (
            month[i].month == 'March' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.MAR : '899';
          } else if (month[i].month == 'March' && this.months[i].usage != '') {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'April' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.APR : '872';
          } else if (month[i].month == 'April' && this.months[i].usage != '') {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'May' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.MAY : '1003';
          } else if (month[i].month == 'May' && this.months[i].usage != '') {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'June' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.JUN : '1380';
          } else if (month[i].month == 'June' && this.months[i].usage != '') {
            month[i].usage = this.months[i].usage;
          }

          if (
            month[i].month == 'July' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.JUL : '1646';
          } else if (month[i].month == 'July' && this.months[i].usage != '') {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'August' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.AUG : '1725';
          } else if (month[i].month == 'August' && this.months[i].usage != '') {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'September' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.SEP : '1689';
          } else if (
            month[i].month == 'September' &&
            this.months[i].usage != ''
          ) {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'October' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.OCT : '1469';
          } else if (
            month[i].month == 'October' &&
            this.months[i].usage != ''
          ) {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'November' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.NOV : '1144';
          } else if (
            month[i].month == 'November' &&
            this.months[i].usage != ''
          ) {
            month[i].usage = this.months[i].usage;
          }
          if (
            month[i].month == 'December' &&
            (month[i].usage == null || this.months[i].usage == '')
          ) {
            month[i].usage = result ? result.DEC : '995';
          } else if (
            month[i].month == 'December' &&
            this.months[i].usage != ''
          ) {
            month[i].usage = this.months[i].usage;
          }
          this.user_bot = true;
        }

        if (this.deviceWidth < 768)
        {
          
        }else
        {
          
          setTimeout(() => {
            this.next()
          }, 1000);
          
        }

      });
  }

  setUtilityName(): string {
    const findServiceutility = _.findWhere(this.userResponses, {
        res_question_id: '008',
      }),
      utilityName = findServiceutility.fieldValue.utility;
    return this.actualUtilityName[
      utilityName.indexOf('(') !== -1
        ? utilityName
            .substring(0, utilityName.indexOf('('))
            .replace(/\s/g, '')
            .replace(/-/g, '')
        : utilityName.replace(/\s/g, '')
    ];
  }

  setSqftValuePerSize() {
    const findServicesqft = _.findWhere(this.userResponses, {
      res_question_id: '0011',
    });
    let sqft;
    if (findServicesqft.fieldName == 'sqft_size') {
      if (findServicesqft.fieldValue < 1250) {
        sqft = '< 1250';
      } else if (findServicesqft.fieldValue > 2250) {
        sqft = '> 2250';
      } else if (
        findServicesqft.fieldValue >= 1250 &&
        findServicesqft.fieldValue <= 2250
      ) {
        sqft = '>=1250 AND <= 2250';
      }
      return sqft;
    }
  }

  setDwellingTypeForProperty() {
    const findService33 = _.findWhere(this.userResponses, {
      res_question_id: '009',
    });
    if (findService33.fieldName == 'property') {
      return this.loadPropertyValues[
        findService33.fieldValue.replace(/\s/g, '')
      ];
    }
  }

  assignClassPerValueEntered(monthElements) {
    monthElements.map((row, i) => {
      monthElements[i].classList.add('valueEntered');
    });
  }

  enableButton(monthId) {
    const findEmpty = _.findWhere(this.months, { usage: '' });
    const findNull = _.findWhere(this.months, { usage: null });
    const findUndefined = _.findWhere(this.months, { usage: undefined });
    if (findEmpty || findNull || findUndefined) {
      this.user_bot = false;
    } else {
      this.user_bot = true;
    }
    const monthElement = <HTMLInputElement>document.getElementById(monthId);
    if (
      monthElement.classList.contains('valueEntered') &&
      monthElement.value == ''
    ) {
      monthElement.classList.remove('valueEntered');
    }
  }

  onKey(event) {
    let monthValue = event.target.value;
    if (monthValue.length > 5) {
      /// document.getElementById("monthChange").classList.add('myClass');
      event.preventDefault();
    }
  }

  next() {
    const self = this;
    let isEmpty = false;
    let totalUsage: number = 0;
    this.months.map((item) => {
      if (
        !isEmpty &&
        (item.usage === '' || item.usage === undefined || item.usage === null)
      ) {
        self.validation = true;
        isEmpty = true;
      } else totalUsage += item.usage;
    });

    const usageObject = {
      totalUsage: totalUsage,
      modified: true,
    };
    sessionStorage.setItem('totalUsageValue', JSON.stringify(usageObject));
    if (isEmpty) {
      //this.getMonthsDetails();
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
    } else {
      this.user_bot = true;
      const Obj = {
        res_question_id: this.data,
        fieldName: 'usage_history',
        fieldValue: this.months,
      };
      this.residentialService.updateResponses(Obj);
      this.residentialService.setStatus('Completed');
      sessionStorage.setItem(
        'questionStatusObj',
        JSON.stringify(this.residentialService.questionnaireStatusObj)
      );
      const questionObj = this.residentialService.questionnaireStatusObj;
      const questionnarieObj = this.residentialService.userResponse;
      const hg_accountId = window.location.href.split('/').pop();
      const user = {
        _id: hg_accountId,
        accountId: hg_accountId,
        questionStatusObj: questionObj,
      };
      const url = window.location.href;
      const urlArr = url.split('/');
      if (
        !_.isEmpty(this.residentialService.user) &&
        _.isEmpty(this.residentialService['user']['questionStatusObj'])
      ) {
        this.residentialService['user']['questionStatusObj'] = questionObj;
      }
      if (
        urlArr &&
        urlArr.length !== 0 &&
        urlArr[4] === 'residentialQues' &&
        urlArr[5] === 'add-address'
      ) {
        this.addAddressFlow = true;
        this.residentialService.user = user;
        this.residentialService.questionFlowType = urlArr[5];
      }
      if (this.addAddressFlow || this.residentialService.user) {
        this.router.navigateByUrl('/pre-success');
      } else {
        this.router.navigateByUrl('/pre-success');
      }
    }
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
  }

  onChange(event) {
    const value = event;
    if (event.toString().length > '5') {
      return false;
    }
  }
}
